import React from "react";
import { Checkbox, Group, TextInput } from "@mantine/core";
import { Controller, useFormContext } from "react-hook-form";
import RHFRadioGroup from "../../../../../../components/form/RHFRadioGroup";
import RHFNumberInput from "../../../../../../components/form/RHFNumberInput";
import { ReactComponent as AttentionCircleRed } from "../../../../../../assets/Attention Circle Red.svg";
import RHFCheckboxGroup from "../../../../../../components/form/RHFCheckboxGroup";
import RHFTextInput from "../../../../../../components/form/RHFTextInput";

const expenseCategoryOptions = [
  { label: "Transportation", value: "Transportation" },
  { label: "Lodging", value: "Lodging" },
  { label: "Food", value: "Food" },
  { label: "Other", value: "Other" },
];

const ExpensesReimbursement = ({ setActive, setTemporaryOpened }) => {
  const { watch, trigger, setValue, control } = useFormContext();

  const type_of_claim = watch("type_of_claim");
  const exp_reimbursement = watch("exp_reimbursement");

  const selectedCategories = watch("exp_categories") || [];

  console.log(selectedCategories)
  const isOtherSelected = selectedCategories.includes("Other");

  const handleBack = () => {
    // If original claim was cancelled, step 4 (Actual flights taken) was skipped
    if (type_of_claim === "cancelled") {
      setActive((c) => c - 2);
    } else {
      setActive((c) => c - 1);
    }
  };

  const handleNext = async () => {
    if (exp_reimbursement === "yes") {
      const isValid = await trigger(["exp_reimbursement", "exp_reimbursement_amount", 'exp_other_category', 'exp_categories']);
      if (!isValid) return;
    } else {
      const isValid = await trigger(["exp_reimbursement"]);
      if (!isValid) return;
    }

    setActive((c) => c + 1);
  };

  return (
    <div className="stepper-container">
      <div className="stepper-header-container">
        <h3 className="stepper-header" style={{ margin: 0 }}>
          Claim for expenses reimbursement
        </h3>
      </div>

      <div >
        <h4 className="stepper-sub-header" style={{ marginBottom: "15px" }}>
          Do you want to claim for expenses reimbursement?
          <span style={{ color: "#de8385" }}> *</span>
        </h4>

        <Group mb="sm" align="center">
          <RHFRadioGroup
            name="exp_reimbursement"
            orientation="horizontal"

            rules={{ required: "Please select an option" }}
            onValueChange={(val) => {
              if (val === "no") {
                setValue("exp_reimbursement_amount", "");
              }
            }}
            options={[
              { label: "Yes", value: "yes" },
              { label: "No", value: "no" },
            ]}
          />
        </Group>

        {exp_reimbursement === "yes" && (
          <div style={{ marginTop: "25px" }}>
            <h4
              className="stepper-sub-header"
              style={{ marginBottom: "10px", fontSize: "16px", fontWeight: 500 }}
            >
              Please enter the total Dollar amount you are claiming
              <span style={{ color: "#de8385" }}> *</span>
            </h4>

            <div style={{ maxWidth: "360px" }}>
              <RHFNumberInput
                name="exp_reimbursement_amount"
                allowDecimal={true}
                placeholder="0.00"
                leftSection={
                  <span style={{ color: "#7B8287", fontWeight: 600, fontSize: "15px" }}>
                    $
                  </span>
                }
                rules={{ required: 'Please enter the total Dollar amount you are claiming' }}
              />
            </div>



            <h4
              className="stepper-sub-header"
              style={{ marginBottom: "10px", marginTop: '20px', fontSize: "16px", fontWeight: 500 }}
            >
              Select expence categories
              <span style={{ color: "#de8385" }}> *</span>
            </h4>

            <RHFCheckboxGroup

              name="exp_categories"
              options={expenseCategoryOptions}
              orientation="horizontal"
              gap="lg"
              rules={{
                validate: (value) =>
                  value?.length > 0 || "Select at least one expense category",
              }}
            />



            {isOtherSelected && (

              <>
                <h4
                  className="stepper-sub-header"
                  style={{ marginBottom: "8px", marginTop: '20px', fontSize: "16px", fontWeight: 500 }}
                >
                  Please specify
                  <span style={{ color: "#de8385" }}> *</span>
                </h4>

                <Controller
                  name="exp_other_category"
                  control={control}
                  rules={{
                    required: "Please specify the expense category",
                    pattern: {
                      value: /^[a-zA-Z0-9 ]+$/,
                      message: "Only letters, numbers, and spaces are allowed",
                    },
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextInput
                      {...field}
                      style={{ maxWidth: "360px" }}

                      required
                      placeholder="Enter expense category"
                      error={error?.message}
                      onChange={(event) => {
                        const value = event.currentTarget.value.replace(
                          /[^a-zA-Z0-9 ]/g,
                          ""
                        );
                        field.onChange(value);
                      }}
                    />
                  )}
                />
              </>

            )}


          </div>
        )}
      </div>

      <div className="stepper-btn-wrapper" style={{ marginTop: "40px" }}>
        <button
          className="secondary-btn new-back-btn"
          type="button"
          onClick={handleBack}
        >
          Back
        </button>

        <div className="add-btn-wrapper">
          <button
            className="secondary-btn"
            type="button"
            onClick={() => setTemporaryOpened(true)}
          >
            Temporary Save
          </button>

          <button onClick={handleNext} className="primary-btn" type="button">
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpensesReimbursement;
